import { ArtifactType } from '@/shared/types';

import { FileType } from './fileHelper';

export const ArtifactFileTypeMapping: Record<ArtifactType, FileType> = {
  [ArtifactType.EXTRACT]: FileType.PDF,
  [ArtifactType.RECEIPT]: FileType.PDF,
  [ArtifactType.SIGN]: FileType.SIGNATURE,
  [ArtifactType.MESSAGE]: FileType.PDF,
  [ArtifactType.INSURANCE]: FileType.ZIP,
  [ArtifactType.BUNDLE]: FileType.ZIP,
  [ArtifactType.APPLICATION]: FileType.PDF,
  [ArtifactType.REFUSAL]: FileType.PDF,
  [ArtifactType.RECEIPT_ARCHIVE]: FileType.ZIP,
};

export const createArtifactRequestHeaders = (artifactType: ArtifactType): Headers => {
  const headers = new Headers();
  headers.set('Accept', ArtifactFileTypeMapping[artifactType]);
  headers.set('Content-Type', 'application/octet-stream');

  return headers;
};
